import {GenericAPI} from "./generic-api-client";

export default GenericAPI("public/periods");
